/**
 * Curated palette of sidebar background themes.
 * Each theme is a dark colour that pairs well with the sidebar's coloured
 * brand-icons + bold shortcut letters. The 'name' is shown in the picker.
 *
 * The empty bg ("") is the canonical "Default (Light)" option which restores
 * the original white sidebar — used when the user hasn't picked a custom theme.
 */
export const SIDEBAR_THEMES = [
  { id: '',         name: 'Default',       bg: '#FFFFFF', dark: false },
  { id: 'slate',    name: 'Slate',         bg: '#0F172A', dark: true  },
  { id: 'midnight', name: 'Midnight Blue', bg: '#1E3A8A', dark: true  },
  { id: 'forest',   name: 'Forest',        bg: '#064E3B', dark: true  },
  { id: 'plum',     name: 'Plum',          bg: '#4C1D95', dark: true  },
  { id: 'crimson',  name: 'Crimson',       bg: '#7F1D1D', dark: true  },
  { id: 'charcoal', name: 'Charcoal',      bg: '#18181B', dark: true  },
  { id: 'teal',     name: 'Deep Teal',     bg: '#134E4A', dark: true  },
];

/**
 * Resolve a stored sidebar_bg value (which may be a theme id OR a hex string)
 * to the actual hex colour to render. Empty / unknown values fall back to white.
 */
export const resolveSidebarBg = (stored) => {
  if (!stored) return '#FFFFFF';
  const match = SIDEBAR_THEMES.find(t => t.id === stored || t.bg.toLowerCase() === stored.toLowerCase());
  if (match) return match.bg;
  // Allow raw #rrggbb passthrough for forward-compat / admin overrides.
  if (/^#[0-9a-fA-F]{6}$/.test(stored)) return stored;
  return '#FFFFFF';
};

/**
 * Returns true when the resolved background is dark enough that we should
 * switch to white-on-dark text styling for sidebar items.
 * Uses a relative-luminance threshold (0..255 in sRGB approx).
 */
export const isDarkBg = (hex) => {
  if (!hex) return false;
  const m = /^#([0-9a-fA-F]{6})$/.exec(hex);
  if (!m) return false;
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 0xff, g = (n >> 8) & 0xff, b = n & 0xff;
  // sRGB relative luminance
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return lum < 130;
};
